import React from "react";

const DeleteRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.75 5.75L5.59115 15.4233C5.68102 16.4568 6.54622 17.25 7.58363 17.25H12.4164C13.4538 17.25 14.319 16.4568 14.4088 15.4233L15.25 5.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.75 5.5V4.75C7.75 3.64543 8.6454 2.75 9.75 2.75H10.25C11.3546 2.75 12.25 3.64543 12.25 4.75V5.5",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 5.75H17",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DeleteRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;